import Toast from '@/Toast';
import { show } from '@ebay/nice-modal-react'
import Message from '@/popup/Message';

export const RegisterErrorHandler = (error) => {
    const errorCode = error?.errors?.[0]?.errorCode;
    const text = error?.errors?.[0]?.description || error?.errors?.[0]?.message || "注册失败";
    if (errorCode === 'MEM00206') {
        Toast.fail(text, 2);
    } else if (errorCode === 'MEM00207' || errorCode === 'MEM00208') {
        show(Message, { title: "密码存在风险", text: text || '您的密码与个人信息或常见密码过于相似，请重设更安全的密码', buttonProps: { hidden: false, text: '重新设置' }, type: 'pwdError' });
    } else {
        show(Message, { title: "注册失败", text });
    }
    console.log("error", error);
}
